export default __webpack_public_path__ + "static/media/Sequel100Black-65.e4003b0d.ttf";